import React, { useState, useEffect } from "react";
import "./CareServiceProfile.css";
import StarRating from "./UserPatientScreen/StarRating";
import Modal from "./UserCalendarScreen/CalendarMainModal";
import PromptModal from "./ReuseComponent/PromptModal";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import { FaArrowLeft } from "react-icons/fa";
const CareServiceProfile = ({
  setSelectedSection,
  selectedCareService,
  loggedIn,
}) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [searchParams] = useSearchParams();
  const [service, setService] = useState(location.state?.data || null);
  const [loading, setLoading] = useState(!location.state?.data);
  const imgIndex = location.state?.imgIndex || 1;

  const toggleIsRefresh = () => {
    setIsRefresh(!isRefresh);
  };

  const moveToLoginPage = () => {
    navigate("/login");
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    // Nếu đã có dữ liệu rồi thì không làm gì cả
    if (service) return;

    const idFromUrl = searchParams.get("id");

    const fetchData = async () => {
      if (idFromUrl) {
        setLoading(true);

        const res = await axiosReqConfig(`${API_IP}/api/services`, "get");
        const result = res?.ok ? res.data : null;

        if (result && Array.isArray(result)) {
          const foundService = result.find(
            (s) => s.care_service_id == idFromUrl,
          );

          if (foundService) {
            setService(foundService);
          } else {
            navigate("/UserHome", { replace: true });
          }
        } else {
          navigate("/UserHome", { replace: true });
        }
        // -----------------------------------------

        setLoading(false);
      } else {
        navigate("/UserHome", { replace: true });
      }
    };

    fetchData();
  }, [service, searchParams, navigate]);

  if (loading || !service) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
      >
        <h2>Loading Service...</h2>
      </div>
    );
  }

  return (
    <>
      {service != null ? (
        <div className="CSP-container">
          <div className="back-button-container">
            <button onClick={handleBackClick} className="profile-back-button">
              <FaArrowLeft className="back-icon" />
              <span>Back</span>
            </button>
          </div>

          {loggedIn ? (
            <Modal
              showModal={showModal}
              handleClose={closeModal}
              preSelectedService={service}
              toggleRefresh={toggleIsRefresh}
              setSelectedSection={setSelectedSection}
            />
          ) : (
            <PromptModal
              title={
                "You need to login in order to book an appointment. Go to login page?"
              }
              type={"binary"}
              showModal={showModal}
              handleClose={closeModal}
              handleConsent={moveToLoginPage}
            />
          )}

          <div className="CSP-main-card">
            <div className="CSP-image-wrapper">
              <img
                src={require(`../images/care_service_${imgIndex}.png`)}
                alt={service.care_service_name}
                className="CSP-image"
              />
            </div>

            <div className="CSP-info-wrapper">
              <h1 className="CSP-title">{service.care_service_name}</h1>

              <div className="CSP-stats-row">
                <div className="CSP-stat-item">
                  <span className="CSP-stat-label">Location</span>
                  <span className="CSP-stat-value">Victoria</span>
                </div>
                <div className="CSP-stat-item">
                  <span className="CSP-stat-label">Average Rate</span>
                  <span className="CSP-stat-value">
                    ${service.hourly_rate}/hr
                  </span>
                </div>
                <div className="CSP-stat-item">
                  <span className="CSP-stat-label">Minimum Hours</span>
                  <span className="CSP-stat-value">{service.min_hours}h</span>
                </div>
              </div>

              <div className="CSP-description">
                <h3>Description</h3>
                <p>
                  {service.description ||
                    "No description available for this service."}
                </p>
              </div>

              <button className="CSP-schedule-btn" onClick={openModal}>
                Schedule {service.care_service_name}
              </button>
            </div>
          </div>

          <div className="CSP-includes-section">
            <h2 className="CSP-section-title">This service includes</h2>
            <div className="CSP-subservices-grid">
              {service.sub_services.map((subService, index) => (
                <div className="CSP-subservice-card" key={index}>
                  <div className="CSP-subservice-number">{index + 1}</div>
                  <div className="CSP-subservice-desc">
                    {subService.description}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="CSP-note-section">
            <p>
              <strong>Note: </strong>
              {service.care_service_name} are non-medical in nature. iCare
              Village caregivers do not provide medical treatment, clinical
              assessments, or medication administration.
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CareServiceProfile;
